// extracted by mini-css-extract-plugin
export default {"button":"Button_button__wiIYs","red":"Button_red__qhH5+","blue":"Button_blue__Hvucl","green":"Button_green__jsHpm","dark":"Button_dark__Igq1v"};